import axiosInstance from "./axiosInstance";

const uploadService = {
  /** Blog/editor / generic admin media → admin/blog/editor/ */
  single: async (file) => {
    try {
      let formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(
        "admin/users/upload/image",
        formData
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  editorImage: async (file) => {
    try {
      let formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(
        "admin/users/upload/image",
        formData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  /** App-user profile photo → {userId}/images/ or admin/users/images/ */
  profileImage: async (file, userId = null) => {
    try {
      let formData = new FormData();
      formData.append("file", file);
      if (userId != null && String(userId).trim() !== "") {
        formData.append("userId", String(userId));
      }
      const response = await axiosInstance.post(
        "admin/users/upload/profile-image",
        formData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default uploadService;
